/*
 * Custom vídeo thumbnail
*/
	const siteVideo = document.querySelectorAll('[site-video]')

	if (siteVideo) {
		siteVideo.forEach(e => {
			e.addEventListener('click', c => {
				c.preventDefault()

				const container = e.parentElement
				const iframe = `<iframe class="mr--i_full" src="${e.dataset.embed}?autoplay=1&rel=0&controls=1&showinfo=0&muted=1" width="560" height="315" frameborder="0" allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
				const delay = (parseFloat(window.getComputedStyle(e).transitionDuration) * 1000) + 100

				container.classList.add('is--playing')

				setTimeout(_ => {
					container.innerHTML = iframe
				}, delay);
			})
		})
	}
